<template>
  <div v-show="showElements" class="video-info-extract-wrapper">
    <div class="video-demo-container">
      <img ref="thumbnail" src="" />
      <video ref="videoElement" controls>
        <source type="video/mp4" />
      </video>
      <canvas ref="canvasElement"></canvas>
    </div>
  </div>
</template>

<script>
import logger from '@goldcast/logger';

export default {
  name: 'VideoInfo',
  props: {
    videoFile: {
      type: File,
      default: null
    },
    thumbnailFrom: {
      type: Number,
      default: 1.0
    },
    showElements: {
      // for debugging, video and generated thumbnail can be shown on UI by setting it true
      type: Boolean,
      default: false
    }
  },
  watch: {
    videoFile() {
      this.initDataExtract();
    }
  },
  methods: {
    initDataExtract() {
      // load the file to a video player
      const videoPlayer = this.$refs.videoElement;
      videoPlayer.setAttribute('src', URL.createObjectURL(this.videoFile));
      videoPlayer.load();
      videoPlayer.addEventListener('error', ex => {
        logger.error('VideoInfo', 'Error when loading video file', ex);
        this.$emit('error', 'Error while loading video file.');
      });
      // load metadata of the video to get video duration and dimensions
      videoPlayer.addEventListener('loadedmetadata', () => {
        // seek to user defined timestamp (in seconds) if possible
        if (videoPlayer.duration < this.thumbnailFrom) {
          logger.error('VideoInfo', 'Video is too short.', {
            videoDuration: videoPlayer.duration,
            thumbnailFrom: this.thumbnailFrom
          });
          this.$emit('error', 'video is too short.');
          return;
        }
        // delay seeking or else 'seeked' event won't fire on Safari
        setTimeout(() => {
          videoPlayer.currentTime = this.thumbnailFrom;
        }, 200);
        videoPlayer.addEventListener('seeked', () => {
          const canvas = this.$refs.canvasElement;
          canvas.width = videoPlayer.videoWidth;
          canvas.height = videoPlayer.videoHeight;
          // draw the video frame to canvas
          const ctx = canvas.getContext('2d');
          ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
          // observe canvas image as a blob
          ctx.canvas.toBlob(
            blob => {
              if (!blob) {
                this.$emit('error', 'Failed to generate thumbnail.');
                return;
              }

              if (!this.$refs.thumbnail) {
                this.$emit('error', 'Thumbnail image element not found.');
                return;
              }

              this.$refs.thumbnail.setAttribute('src', URL.createObjectURL(blob));
              const duration = Math.round(videoPlayer.duration);
              if (isNaN(duration)) {
                this.$emit('error', 'Invalid video duration.');
                return;
              }

              try {
                const thumbnailFile = new File([blob], 'thumbnail.jpeg');
                this.$emit('dataExtracted', {
                  thumbnailBlob: blob,
                  thumbnailFile,
                  duration
                });
              } catch (e) {
                this.$emit('error', 'Failed to create thumbnail file.');
                return;
              }
            },
            'image/jpeg',
            0.75 /* quality */
          );
        });
      });
    }
  }
};
</script>
